import React, { useState } from "react";
import ClassNames from "classnames";
import ActionsMenu from "../ActionsMenu/ActionsMenu.js";
import IconButton from "../../controls/Buttons/IconButton/IconButton.js";
import type { ActionsMenuItem } from "../ActionsMenu/ActionsMenu";

export interface SidebarItemActionsProps {
  actions: ActionsMenuItem[];
  isActive: boolean;
  title: string;
  "data-testid": string;
}

const SidebarItemActions: React.FC<SidebarItemActionsProps> = ({
  actions,
  isActive,
  title,
  "data-testid": dataTestId,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ActionsMenu
      className="sidebar-item-actions"
      data-testid={`${dataTestId}-item-actions-${title}`}
      menuItems={actions}
      onMenuOpenChange={setIsOpen}
      place="bottom-start"
    >
      <IconButton
        isIcon="seem-icon-more-actions"
        className={ClassNames("sidebar-item-actions-trigger", {
          active: isOpen || isActive,
        })}
      />
    </ActionsMenu>
  );
};

export default SidebarItemActions;
